module.exports = __webpack_public_path__ + "static/img/wq_pc.1a380e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/wq_pc.png
// module id = ZQ9f
// module chunks = 0